(() => {
  const init = () => {
    if (typeof Intl.DisplayNames === 'function') {
      const regions = new Intl.DisplayNames(['zh-Hant'], { type: 'region' });
      document.querySelectorAll('[data-ob-country]').forEach(option => {
        option.textContent = `${regions.of(option.dataset.obCountry)} · ${option.dataset.obCurrency}`;
      });
    }
    document.querySelectorAll('[data-outsider-home]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const buttons = root.querySelectorAll('[data-ob-filter]');
      const cards = root.querySelectorAll('[data-ob-book]');
      const status = root.querySelector('[data-ob-book-status]');
      buttons.forEach(button => button.addEventListener('click', () => {
        let count = 0;
        buttons.forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
        cards.forEach(card => { card.hidden = button.dataset.obFilter !== 'all' && card.dataset.category !== button.dataset.obFilter; if (!card.hidden) count++; });
        status.textContent = count ? root.dataset.countText.replace('%count%', count) : root.dataset.emptyText;
      }));
      const family = root.querySelector('#ob-family-count');
      const total = root.querySelector('#ob-member-total');
      family.addEventListener('input', () => {
        const value = Number(family.value);
        if (!family.value || !Number.isInteger(value) || value < 0 || value > 20) { total.textContent = root.dataset.invalidText; return; }
        total.textContent = `¥${(33000 + value * 3300).toLocaleString('ja-JP')}`;
      });
      const archive = root.querySelector('[data-ob-past]');
      const refreshEvents = () => {
        root.querySelectorAll('[data-ob-upcoming] [data-ob-event]').forEach(event => {
          const end = Date.parse(event.dataset.end);
          if (!Number.isFinite(end) || Date.now() <= end) return;
          event.querySelectorAll('[data-ob-register], [data-ob-registration-note]').forEach(el => { el.hidden = true; });
          const label = event.querySelector('.ob-event-past');
          if (label) label.hidden = false;
          if (archive) archive.prepend(event);
        });
      };
      refreshEvents();
      setInterval(refreshEvents, 60000);
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) root.querySelectorAll('[data-ob-jump]').forEach(a => { if (a.dataset.obJump === entry.target.id) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); }); });
      }, { rootMargin: '-15% 0px -50% 0px', threshold: 0 });
      ['books', 'membership', 'events'].forEach(id => { const section = root.querySelector(`#${id}`); if (section) observer.observe(section); });
    });
    document.querySelectorAll('.ob-mobile-menu a').forEach(a => a.addEventListener('click', () => { a.closest('details').open = false; }));
    document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.ob-header details[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); }); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

